/* eslint-disable eqeqeq */
import React from "react";
import axios from "axios";
import URL from "../../constants/API_URL";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Card, Input, Icon, Button, Checkbox } from "antd";
import "./Injaz-LoginScreen.css";
import { loginThunka } from "../../redux/actions/posloginAction.js";
import API_URL from "../../constants/API_URL";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import LanguageChangingDropdown from "../../components/LanguageChangingDropdown";

class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientUsersList: [],
      username: "",
      layoutName: "default",
      input: "",
    };
  }
  setUserToLogIn = (item) => {
    // document.getElementById("password").blur()
    this.setState({ username: item.username }, () => {
      // document.getElementById("password").focus()
    });
  };
  onChange = (input) => {
    this.setState({
      input: input,
    });
    // console.log("Input changed", input);
  };
  onKeyPress = (button) => {
    // console.log("Button pressed", button);
    if (button === "{enter}") {
      this.handleSubmit();
    }
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };
  handleShift = () => {
    let layoutName = this.state.layoutName;

    this.setState({
      layoutName: layoutName === "default" ? "shift" : "default",
    });
  };
  onChangeInput = (event) => {
    let input = event.target.value;
    this.setState(
      {
        input: input,
      },
      () => {
        this.keyboard.setInput(input);
      },
    );
  };

  componentWillMount() {
    let thiss = this;

    localStorage.getItem("accessToken") &&
      axios({
        method: "POST",
        url: URL + "auth/validateToken",
        data: {
          bearerToken:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (!res.data) {
            localStorage.clear();
            this.props.history.push("/poslogin");
            window.location.reload();
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.props.history.push("/poslogin");
          window.location.reload();
        });
    axios({
      url: API_URL + "posUsersByClientName",
      method: "GET",
      params: {
        clientName: thiss.props.history.location.pathname.split("/")[2],
      },
    })
      .then((res) => {
        this.setState({ clientUsersList: res.data });
        if (res.data.length > 0) {
        } else {
          this.props.history.replace("/poslogin/sandwichFactory.");
          window.location.reload();
        }
      })
      .catch((err) => {
        this.setState({ clientUsersList: [] });
        this.props.history.replace("/poslogin/sandwichFactory.");
        window.location.reload();
      });
  }
  handleSubmit = () => {
    // e.preventDefault();
    // this.props.form.validateFields((err, values) => {
    //   if (!err) {
    if (this.state.input && this.state.username) {
      const body = {
        usernameOrEmail: this.state.username,
        password: this.state.input,
      };
      this.props.loginThunka(body);
    }
    // }
    // })
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { props } = this;
    const lang = props.language.INJAZ_AUTH_LOGINFORM;
    const direction = props.language.INJAZ_AUTH_DIRECTION;

    if (this.props.user.clientId && this.props.user.accessToken) {
      return (
        <Redirect
          to={{
            pathname: "/pos",
          }}
        />
      );
    } else {
      return (
        <React.Fragment>
          <div
            className="backgroundImagepos"
            style={{
              display: "block",
            }}
          >
            <Card
              style={{
                width: "100%",
                float: localStorage.getItem("lang") == "EN" ? "left" : "right",
                border: "none",
              }}
            >
              {this.state.clientUsersList.length > 0 &&
                this.state.clientUsersList.map((item, index) => (
                  <Card
                    key={index}
                    onClick={() => this.setUserToLogIn(item)}
                    className={`pos_client_images ${
                      item.username == this.state.username
                        ? "pos_client_images-selected"
                        : ""
                    }`}
                    style={{
                      float:
                        localStorage.getItem("lang") == "EN" ? "left" : "left",
                      height: "160px",
                      margin: "10% 2% 0px 2%",
                      cursor: "pointer",
                      width: "145px",
                    }}
                    // eslint-disable-next-line jsx-a11y/alt-text
                    cover={
                      <img
                        onClick={() => this.setUserToLogIn(item)}
                        style={{ width: "145px", height: "145px" }}
                        src={`${API_URL}getProductImage?clientName=${item.clientName}&imageName=${item.profileImg}&imageContent=${item.imageContent}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/placeholderImage.jpg";
                        }}
                      />
                    }
                  >
                    <Card.Meta
                      title={item.username}
                      onClick={() => this.setUserToLogIn(item)}
                    />
                  </Card>
                ))}
            </Card>
            {/* <Card className=" login-form pos_login_form" style={{ float: localStorage.getItem('lang') == 'EN' ? 'right' : 'left', margin: "5% 5%", height: '450px', background: '#fff', width: '100%' }}>
              <div style={{ backgroundColor: '#dd4449 !important', width: '30px', float: 'right', padding: '20px' }}>
                <LanguageChangingDropdown />
              </div>
              <img src="logo2.png" alt="logo2"
                onError={(e) => { e.target.onerror = null; e.target.src = "/logo2.png" }}
                style={{ opacity: '1', margin: '0 auto', display: 'table', width: '145px' }} />
              <Form onSubmit={this.handleSubmit} style={{ backgroundColor: 'transparent' }}>
                <Form.Item className="login-item" style={{ marginTop: '00px' }}>
                  {getFieldDecorator('email', {
                    rules: [{
                      required: true, message: 'Please input your E-mail!',
                    }], initialValue: this.state.username
                  })(
                    <Input prefix={<Icon type="user" style={{ color: '#F38213' }} />} placeholder={lang.LABELS.EMAIL} dir={direction} />
                  )}
                </Form.Item>
                <Form.Item className="login-item">
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please input your Password!' }],
                  })(
                    <Input.Password prefix={<Icon type="lock" style={{ color: '#F38213' }} />} type="password" id="focusPassword" placeholder={lang.LABELS.PASSWORD} dir={direction} />
                  )}
                </Form.Item>
                <Form.Item className="login-item">
                  {getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true,
                  })(
                    <Checkbox style={{ display: 'none' }}> {lang.LABELS.REMEMBERME}</Checkbox>
                  )}
                  <Button block style={{ marginTop: '0px', backgroundColor: '#F38213', borderColor: '#F38213', borderRadius: '2px', color: '#fff' }} htmlType="submit"  >
                    {lang.BUTTON.LOGIN}
                  </Button>
                </Form.Item>
              </Form>
            </Card> */}
            {/* <Card className=" login-form pos_login_form" style={{ float: localStorage.getItem('lang') == 'EN' ? 'right' : 'left', margin: "5% 5%", height: '450px', background: '#fff', width: '100%' }}> */}

            {this.state.username && (
              <div className="posUSerInput">
                <input
                  className="showInputCalculator"
                  value={this.state.input}
                  placeholder={""}
                  type="password"
                  onChange={(e) => this.onChangeInput(e)}
                />
                <Keyboard
                  keyboardRef={(r) => (this.keyboard = r)}
                  onChange={(input) => this.onChange(input)}
                  onKeyPress={(button) => this.onKeyPress(button)}
                  layoutName={this.state.layoutName}
                  layout={{
                    default: [
                      "1 2 3",
                      "4 5 6",
                      "7 8 9",
                      "{shift} 0 {bksp}",
                      "{enter}",
                    ],
                    shift: [
                      "! / #",
                      "$ % ^",
                      "& * (",
                      "{shift} ) {bksp}",
                      "{enter}",
                    ],
                  }}
                  theme={"hg-theme-default hg-layout-numeric numeric-theme"}
                />
              </div>
            )}
            {/* </Card> */}
          </div>
        </React.Fragment>
      );
    }
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loginThunka: (body) => dispatch(loginThunka(body)),
  };
};
const WrappedNormalLoginForm = Form.create()(NormalLoginForm);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(WrappedNormalLoginForm));
